import React from 'react'
import { Badge } from '@/components/ui/badge'

class LeadLabelsPartial extends React.Component {

  render() {
    const label = this.props.label

    if (label.type == 'warning') {
      return (
        <Badge variant="warning">{this.props.label.name}</Badge>
      )
    }
    else {
      return (
        <Badge variant="secondary">{this.props.label.name}</Badge>
      )
    }
  }
}

export default LeadLabelsPartial
